<template>
  <div style="padding: 14px;">
    <!-- <div style="text-align: right;color:#999999;font-size: 14px;" class="mb-10">
      当前通信费累计： <span style="color:#FFB85A;font-size: 24px;">{{ seatsData.totalFee||'0' }} <i style="font-size: 14px;">元</i></span>
    </div> -->
    <el-row class="row-top" :gutter="24">
      <el-col :span="6">
        <div>
          <img src="@/assets/call/phone1.png" alt />
          <div>
            <h5 style="color:#374FB8;">{{ seatsData.callDurationCount||'00:00' }}</h5>
            <p>通话时长</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div>
          <img src="@/assets/call/phone2.png" alt />
          <div>
            <h5 style="color:#27D5DF;">{{ seatsData.callSuccessCount||'0' }}</h5>
            <p>拨通数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div>
          <img src="@/assets/call/phone3.png" alt />
          <div>
            <h5 style="color:#FF414F;">{{ seatsData.callFailCount||'0' }}</h5>
            <p>未通数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div>
          <img src="@/assets/call/phone4.png" alt />
          <div>
            <h5 style="color:#FFB85A;">{{ seatsData.percent||'0%' }}</h5>
            <p>接通率</p>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="div-screen">
      <div class="div-row">
        <span class="span-lable">外呼员工：</span>
        <!-- <el-select v-model="userIds" placeholder="请选择外呼员工" size="small" filterable class="" multiple collapse-tags style="width:280px;" @change="getSeatsCallDataList">
          <el-option v-for="(item,index) in customerEmpoyArr" :key="index" :label="item.accountName" :value="item.id"></el-option>
        </el-select> -->
        <el-cascader popper-class="cascader-department" ref="cascader" size="small" style="width:280px;" filterable placeholder="请选择外呼员工" :options="options" :show-all-levels="false" :props="props1"
          v-model="ownerValue" collapse-tags clearable @change="changeCascader"></el-cascader>
        <span class="span-lable">部门：</span>
        <el-cascader :options="departmentList" popper-class="cascader-department" @change="changeDepartment" filterable :show-all-levels="false" v-model="cascader" style="width:280px;" :props="props"
          size="small" placeholder="请选择部门" class="mr-10" collapse-tags clearable></el-cascader>
        <a class="a-btn" @click="clickReset"><img src="@/assets/call/icon-chongzhi.png" alt /> 重置</a>
      </div>
      <div class="div-row">
        <span class="span-lable">拨打时间：</span>
        <template></template>
        <span class="span-option" :class="item.value === timeChooseType ? 'is-select' : ' '" v-for="(item,index) in timeOption" :key="index" @click="clickTime(item.value)">{{ item.name }}</span>
        <span class="span-option" style="margin-right: 0px;" :class="isCustom ? 'is-select' : ' '" @click="clickCustom">自定义</span>
        <el-date-picker v-if="isCustom" size="mini" style="width:250px;" :clearable="false" @change="changeDate" v-model="date" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" class="ml-20" />
      </div>
      <div class="div-row">
        <span class="span-lable">状态：</span>
        <span class="span-option" :class="item.value === callStatus ? 'is-select' : ' '" v-for="(item,index) in stateList" :key="index" @click="clickState(item.value)">{{ item.name }}</span>
      </div>
    </div>
    <div class="div-table">
      <p class="p-title mt-10 mb-20">呼叫明细
        <span class="fr">
          <el-button size="mini" type="primary" @click="exportSeatsData">导出</el-button>
        </span>
      </p>
      <el-table :data="tableData" @selection-change="handleSelectionChange" :header-cell-style="{color:'#333'}">
        <el-table-column align="center" type="selection" width="80"></el-table-column>
        <el-table-column prop="callSeatsName" label="姓名" width="180"></el-table-column>
        <el-table-column prop="callSum" label="全部呼叫"></el-table-column>
        <el-table-column prop="callSuccessCount" label="接通数"></el-table-column>
        <el-table-column prop="callFailCount" label="未接通数"></el-table-column>
        <el-table-column prop="callCompletingRate" label="接通率"></el-table-column>
        <el-table-column prop="callDuration" label="通话时长"></el-table-column>
        <el-table-column prop="callDurationAvg" label="平均通话时长"></el-table-column>
      </el-table>
      <pagination :page-num="pageNum" :page-size="pageSize" :total="total" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange" style="margin-top:60px;" />
    </div>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import { formatDate } from '@/base/date'
import { getSeatsCallDataList, getCountSeatsData, exportSeatsData, getDepartTreeStructure, getDepartUserStructure } from '../api'
// import '@/assets/text/text.css'

export default {
  components: { pagination },
  data () {
    return {
      ownerValue: [],
      props1: { multiple: true, label: 'value', value: 'id', children: 'childList' },
      options: [], // type 类型 1：部门 2：员工
      seatsData: {
        totalFee: 0,
        callDurationCount: '00:00',
        callSuccessCount: 0,
        callFailCount: 0,
        percent: '0%'
      },
      userIds: [],
      customerEmpoyArr: [],
      structureList: [],
      pageNum: 1,
      pageSize: 20,
      total: 0,
      isCustom: false,
      input: '',
      props: {
        multiple: true,
        checkStrictly: true,
        children: 'accountDepResults',
        value: 'id',
        label: 'departmentName'
      },
      cascader: '',
      departmentIds: [],
      departmentList: [],
      input3: '',
      callStatus: '0',
      stateList: [{ name: '全部', value: '0' }, { name: '已接通', value: '1' }, { name: '未接通', value: '2' }],
      date: [],
      tableData: [],
      callSeatsId: [],
      timeChooseType: '0',
      timeOption: [{ name: '全部', value: '0' }, { name: '今日', value: '1' }, { name: '昨日', value: '2' }, { name: '近7日', value: '3' }, { name: '近30天', value: '4' }, { name: '近半年', value: '5' }]
    }
  },
  mounted () {
    this.getList()
    this.getSeatsCallDataList()
  },
  updated () {
    this.fixCascader()
  },
  methods: {
    fixCascader () {
      const cascader = document.querySelectorAll('.el-cascader__search-input')
      for (let index = 0; index < cascader.length; index++) {
        cascader[index].setAttribute('placeholder', '')
      }
    },
    changeCascader () {
      this.userIds = []
      this.ownerValue.forEach(e => {
        this.userIds.push(e[e.length - 1])
      })
      this.getSeatsCallDataList()
    },
    getOptions (arr) {
      if (arr && arr.length) {
        arr.forEach(e => {
          this.$set(e, 'disabled', false)
          if (e.type == 2) {
            delete e.childList
          }
          if (e.type == 1 && (e.childList == undefined || e.childList == null || !e.childList || !e.childList.length || e.containFlag !== 1)) {
            e.disabled = true
          }
          if (e.childList && e.childList.length) {
            this.getOptions(e.childList)
          } else {
            delete e.childList
          }
        })
      }
    },
    getDepartUserStructure () {
      getDepartUserStructure().then(res => {
        this.options = res.data
        this.getOptions(this.options)
      }).catch(_ => { })
    },
    changeDepartment (val) {
      // var list = []
      // val.forEach(e => {
      //   e.forEach(x => {
      //     var index = list.indexOf(x)
      //     if (index === -1) {
      //       list.push(x)
      //     }
      //   })
      // })
      this.departmentIds = val ? val.map(item => item[item.length - 1]) : []
      this.getSeatsCallDataList()
    },
    getArr (arr) {
      if (!arr.length) {
        return false
      }
      arr.forEach(e => {
        if (e.accountDepResults.length) {
          this.getArr(e.accountDepResults)
        } else {
          e.accountDepResults = null
        }
      })
      this.departmentList = arr
    },
    getList () {
      getDepartTreeStructure({}).then(res => {
        this.getArr(res.data)
      })
      this.getDepartUserStructure()
      // selectSubordinateUserList().then(res => {
      //   if (res.code == 0) {
      //     this.customerEmpoyArr = res.data
      //   }
      // })
      // queryScrmUsers({}).then(res => {
      //   this.structureList = res.data
      // })
    },
    exportSeatsData () {
      var data = {
        callStatus: this.callStatus,
        departmentIds: this.departmentIds
      }
      if (this.isCustom) {
        data.startTime = this.date[0] ? this.date[0] : ''
        data.endTime = this.date[1] ? this.date[1] : ''
      } else {
        data.timeChooseType = this.timeChooseType
      }
      if (this.callSeatsId.length) {
        data.userIds = this.callSeatsId
      } else {
        data.pageNum = this.pageNum
        data.pageSize = this.pageSize
        data.userIds = this.userIds
      }
      exportSeatsData(data).then(res => {
        this.Global.downloadBlob(res.data, '呼叫明细.xlsx')
      })
    },
    clickReset () {
      this.pageNum = 1
      this.pageSize = 20
      this.userIds = []
      this.ownerValue = []
      this.callStatus = '0'
      this.departmentIds = []
      this.clickCustom()
      this.timeChooseType = '0'
      this.isCustom = false
      this.cascader = ''
      this.getSeatsCallDataList()
    },
    clickCustom () {
      this.timeChooseType = null
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
      this.date = [formatDate(start, 'yyyy-MM-dd'), formatDate(end, 'yyyy-MM-dd')]
      this.isCustom = true
      this.changeDate()
    },
    changeDate () {
      this.getSeatsCallDataList()
    },
    getSeatsCallDataList () {
      var data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        userIds: this.userIds,
        callStatus: this.callStatus,
        departmentIds: this.departmentIds
      }
      if (this.isCustom) {
        data.startTime = this.date[0] ? this.date[0] : ''
        data.endTime = this.date[1] ? this.date[1] : ''
      } else {
        data.timeChooseType = this.timeChooseType
      }
      getSeatsCallDataList(data).then(res => {
        this.tableData = res.data.list
        this.total = Number(res.data.total)
      })
      getCountSeatsData(data).then(res => {
        this.seatsData = res.data
      })
    },
    handleSizeChange (val) {
      this.pageNum = 1
      this.pageSize = val
      this.getSeatsCallDataList()
    },
    handleCurrentChange (i) {
      this.pageNum = i
      this.getSeatsCallDataList()
    },
    handleSelectionChange (val) {
      this.callSeatsId = val.map(x => x.callSeatsId)
    },
    clickState (val) {
      this.callStatus = val
      this.getSeatsCallDataList()
    },
    clickTime (val) {
      this.isCustom = false
      this.timeChooseType = val
      this.getSeatsCallDataList()
    }
  }
}
</script>
<style lang="scss">
.cascader-department {
  max-width: 542px;
  overflow-y: auto;
}
</style>
<style lang="scss" scoped>
.el-cascader {
  /deep/.el-cascader__tags .el-tag {
    max-width: 45% !important;
  }
  /deep/ .el-cascader__search-input {
    height: 24px !important;
  }
  /deep/ input {
    height: 32px !important;
  }
  /deep/ .el-cascader__tags .el-tag {
    margin-top: 5px;
  }
}
.row-top {
  font-family: 'PTRootUI-Medium, PTRootUI';
  .el-col-6 {
    > div {
      background: #fff;
      height: 116px;
      padding: 26px 20px;
      box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
      img {
        width: 64px;
        height: 64px;
        margin-right: 20px;
        position: relative;
        top: -3px;
      }
      div {
        display: inline-block;
        width: calc(100% - 88px);
        position: relative;
        top: 18px;
        h5 {
          position: relative;
          top: -15px;
          font-size: 20px;
          font-weight: bold;
        }
        p {
          position: relative;
          top: -5px;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
}
.div-screen {
  margin-top: 24px;
  margin-bottom: 24px;
  padding: 24px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
  /deep/ .el-select .el-tag__close.el-icon-close {
    right: 0px;
    top: 3px;
  }
  .el-cascader {
    height: 32px !important;
    /deep/ .el-input__inner {
      height: 32px !important;
    }
    /deep/ .el-cascader__tags .el-tag > span {
      flex: auto;
    }
    /deep/ .el-cascader-node__postfix {
      top: 50%;
      transform: translateY(-50%);
    }
    /deep/ .el-cascader__search-input {
      min-width: 40px !important;
    }
  }
  .div-row {
    height: 32px;
    line-height: 32px;
    position: relative;
    /deep/ .el-select__tags .el-tag {
      max-width: 150px !important;
    }
    /deep/ .el-select .el-select__tags > span {
      display: contents !important;
    }
    /deep/ .el-select .el-select__tags > span .el-tag__close.el-icon-close {
      right: -1px;
      top: 3px;
    }
  }
  .div-row + .div-row {
    margin-top: 12px;
  }
  .span-lable {
    display: inline-block;
    text-align: right;
    width: 60px;
    color: #666;
    font-size: 12px;
    margin-right: 8px;
  }
  .a-btn {
    position: relative;
    top: 1px;
    display: inline-block;
    width: 66px;
    height: 32px;
    border: 1px solid #e4e6e8;
    border-radius: 4px;
    line-height: 32px;
    text-align: center;
    color: #666;
    font-size: 12px;
    img {
      position: relative;
      top: -1px;
    }
  }
  .span-option {
    font-size: 12px;
    color: #666;
    cursor: pointer;
    margin-right: 32px;
  }
  .span-option:hover {
    color: #374fb8;
    font-size: 14px;
  }
  .is-select {
    font-size: 14px;
    color: #374fb8;
  }
}
.div-table {
  padding: 24px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
  .el-button--primary {
    background: #374fb8;
    border-color: #374fb8;
    padding: 8.5px 28px;
    margin-left: 24px;
    position: relative !important;
    top: -6px !important;
  }
  .p-title {
    color: #333;
    font-weight: 600;
    border-left: 2px solid #374fb8;
    padding-left: 5px;
    .el-button {
      position: relative;
      top: -5px;
    }
  }
}
</style>
